<span class="color_container">
    <span [ngStyle]="this.style"></span> &nbsp; {{label}}
</span>